module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sslcertificates/bravenet_sslcertificates_seo_boost.png";